var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94165 0.391661C5.82446 0.274619 5.6656 0.208878 5.49998 0.208878C5.33435 0.208878 5.1755 0.274619 5.05831 0.391661L0.891646 4.55833C0.774604 4.67552 0.708862 4.83437 0.708862 4.99999C0.708862 5.16562 0.774604 5.32447 0.891646 5.44166L5.05831 9.60833C5.1755 9.72537 5.33435 9.79111 5.49998 9.79111C5.6656 9.79111 5.82446 9.72537 5.94165 9.60833C6.05869 9.49114 6.12443 9.33229 6.12443 9.16666C6.12443 9.00103 6.05869 8.84218 5.94165 8.72499L2.21665 4.99999L5.94165 1.27499C6.05869 1.15781 6.12443 0.998953 6.12443 0.833328C6.12443 0.667702 6.05869 0.508849 5.94165 0.391661Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.cba3b4657e9e38e6857cba5b14a7a42c.svg";
export { ForwardRef as ReactComponent };